<template>
  <b-modal
    id="sliderOptionsModal"
    v-model="modal.show"
    title="Slider Options"
    ok-only
    @hidden="onHideModal"
    @show="onShow"
  >
    <no-content
      :show="(sunModelData.facts.length === 0 || showAttributes) && sunModelData.dimensions.length === 0 && attributes.length === 0"
    />
    <div v-if="!showAttributes && sunModelData.facts.length > 0">
      <h4>Fact</h4>
      <div>
        <label>Font Size</label>
        <vue-slider
          v-model="fact.fontSize"
          :value="fact.fontSize"
          v-bind="fontOptions"
          @change="onFactFontSizeChange"
        />
      </div>
      <hr>
    </div>
    <div v-if="sunModelData.dimensions.length > 0">
      <h4>Dimension</h4>
      <div>
        <label>Font Size</label>
        <vue-slider
          v-model="dimension.fontSize"
          :value="dimension.fontSize"
          v-bind="fontOptions"
          @change="onFontSizeChange(false)"
        />
      </div>
      <div>
        <label>Link Width</label>
        <vue-slider
          v-model="dimension.width"
          :value="dimension.width"
          v-bind="widthOptions"
          @change="onWidthChange(false)"
        />
      </div>
      <div>
        <label>Link Length</label>
        <vue-slider
          v-model="dimension.length"
          :value="dimension.length"
          v-bind="lengthOptions"
          @change="onLengthChange(false)"
        />
      </div>
    </div>
    <div v-if="showAttributes && attributes.length > 0">
      <hr>
      <h4>Attribute</h4>
      <div>
        <label>Font Size</label>
        <vue-slider
          v-model="attribute.fontSize"
          :value="attribute.fontSize"
          :min="12"
          :max="24"
          :interval="1"
          @change="onFontSizeChange(true)"
        />
      </div>
      <div>
        <label>Link Width</label>
        <vue-slider
          v-model="attribute.width"
          :value="attribute.width"
          v-bind="widthOptions"
          @change="onWidthChange(true)"
        />
      </div>
      <div>
        <label>Link Length</label>
        <vue-slider
          v-model="attribute.length"
          :value="attribute.length"
          v-bind="lengthOptions"
          @change="onLengthChange(true)"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import NoContent from '../../core/components/NoContent';

const {mapState, mapActions} = createNamespacedHelpers('sunModel');
export default {
  name: 'SliderOptionsModal',
  components: {NoContent},
  props: {
    showAttributes: Boolean,
    sunModelData: Object,
  },
  data() {
    return {
      fontOptions: {
        min: 8,
        max: 24,
        interval: 1,
      },
      widthOptions: {
        min: 1,
        max: 5,
        interval: 1,
      },
      lengthOptions: {
        min: 150,
        max: 1000,
        interval: 50,
      },
      dimension: {
        width: 1,
        length: 150,
        fontSize: 8,
      },
      attribute: {
        width: 1,
        length: 150,
        fontSize: 12,
      },
      fact: {
        fontSize: 8,
      },
    };
  },
  computed: {
    ...mapState({
      modal: state => state.sliderModal,
    }),
    attributes() {
      const attributes = [];
      if (this.sunModelData.facts.length > 0) {
        this.sunModelData.facts.forEach(fact => {
          if (fact.attributes.length > 0 && fact.attributes.filter(attr => attr.aggregationType === 'DoNotAggregate').length > 0) {
            attributes.push(fact.attributes);
          }
        });
      }
      if (this.sunModelData.dimensions.length > 0) {
        this.sunModelData.dimensions.forEach(dim => {
          if (dim.attributes.length > 0) {
            attributes.push(dim.attributes);
          }
        });
      }
      return attributes;
    },
  },
  methods: {
    ...mapActions(['hideSliderModal']),
    onShow() {
      if (this.modal.data.dimension) {
        this.dimension = {...this.modal.data.dimension};
      }
      if (this.modal.data.attribute) {
        this.attribute = {...this.modal.data.attribute};
      }
      if (this.modal.data.fact) {
        this.fact = {...this.modal.data.fact};
      }
    },
    onHideModal() {
      this.hideSliderModal();
      this.dimension = {
        width: 1,
        length: 150,
        fontSize: 8,
      };
      this.attribute = {
        width: 1,
        length: 150,
        fontSize: 12,
      };
      this.fact = {
        fontSize: 8,
      };
    },
    onLengthChange(isAttr) {
      this.$emit('on-length-change', isAttr ? this.attribute.length : this.dimension.length, isAttr);
    },
    onWidthChange(isAttr) {
      this.$emit('on-width-change', isAttr ? this.attribute.width : this.dimension.width, isAttr);
    },
    onFontSizeChange(isAttr) {
      this.$emit('on-font-size-change', isAttr ? this.attribute.fontSize : this.dimension.fontSize, isAttr);
    },
    onFactFontSizeChange() {
      this.$emit('on-fact-font-size-change', this.fact.fontSize);
    },
  },
};
</script>

<style scoped>

</style>